import type Album from './Album.js';
import type MediaKind from './MediaKind.js';

interface Track extends MediaKind {
  type: 'track';
  duration?: number;
  seekPosition?: number;
  streamUrl?: string;
  streamUrlHQ?: string;
  album?: Omit<Album, 'type'>;
  position?: number;
  lyrics?: string;
}

export default Track;
